import { jsx as a } from "react/jsx-runtime";
import { useController as f } from "react-hook-form";
import { isDefined as c } from "./types3.mjs";
import { FormControl as u } from "@mui/material";
import { RadioGroup as g } from "./index73.mjs";
const D = ({
  control: m,
  name: o,
  defaultValue: e,
  rules: s,
  shouldUnregister: p,
  onChange: t,
  helperText: d,
  color: C,
  ...h
}) => {
  const {
    field: n,
    fieldState: { error: r }
  } = f({
    name: o,
    control: m,
    rules: s,
    defaultValue: e,
    shouldUnregister: p
  });
  return /* @__PURE__ */ a(u, { error: !!r, children: /* @__PURE__ */ a(
    g,
    {
      defaultValue: e,
      name: o,
      onChange: (i) => {
        const l = i.target.value;
        n.onChange(l), c(t) && t(i, l);
      },
      value: n.value,
      helperText: d || r?.message,
      hasError: !!r,
      ...h
    }
  ) });
};
export {
  D as FormRadioGroupField
};
//# sourceMappingURL=index74.mjs.map
